(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["saber-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('saber-finder')) {
    class SaberFinder extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.step = 0;
        this.answers = {};
        this.keys = ['purpose', 'budget', 'priority'];
        this.panels = [...this.querySelectorAll('[data-step]')];
        this.candidates = [...this.querySelectorAll('template[data-candidate]')];
        this.messages = Object.fromEntries([...this.querySelectorAll('[data-message]')].map(el => [el.dataset.message, el.textContent]));
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.dataset.answer) {
            this.answers[this.keys[this.step]] = button.dataset.answer;
            this.step += 1;
          } else if (button.dataset.action === 'back') {
            this.step = Math.max(0, this.step - 1);
          } else if (button.dataset.action === 'restart') {
            this.step = 0;
            this.answers = {};
          } else if (button.dataset.action === 'budget') {
            this.step = 1;
          } else if (button.dataset.action === 'preferences') {
            this.step = 0;
          } else if (button.dataset.action === 'baselit') {
            this.answers.priority = 'simple';
            this.step = 3;
          } else return;
          this.render(true);
        });
        this.querySelector('[data-finder-ui]').hidden = false;
        this.render(false);
      }

      matchingCandidates() {
        const { purpose, budget, priority } = this.answers;
        if (purpose === 'dueling' && ['effects', 'custom'].includes(priority)) return [];
        const preferred = priority === 'effects' ? ['xenopixel'] : priority === 'custom' ? ['proffie'] : priority === 'simple' || purpose === 'dueling' ? ['baselit'] : purpose === 'collecting' ? ['xenopixel', 'baselit'] : ['baselit', 'xenopixel'];
        const low = Number(this.dataset.low);
        const high = Number(this.dataset.high);
        const matches = this.candidates.map((template, index) => ({ template, index })).filter(({ template }) => {
          const data = template.dataset;
          const price = Number(data.price);
          const inBudget = budget === 'flexible' || (budget === 'low' && price < low) || (budget === 'middle' && price >= low && price <= high) || (budget === 'high' && price > high);
          return data[purpose] === 'true' && preferred.includes(data.core) && Number.isFinite(price) && inBudget;
        }).sort((a, b) => {
          const score = item => preferred.indexOf(item.template.dataset.core) * 100 + (item.template.dataset.focus === purpose ? 0 : 20) + item.index / 100;
          return score(a) - score(b);
        });
        const seen = new Set();
        return matches.filter(({ template }) => {
          if (seen.has(template.dataset.product)) return false;
          seen.add(template.dataset.product);
          return true;
        }).slice(0, 3).map(item => item.template);
      }

      render(focus) {
        const resultsMode = this.step === 3;
        this.panels.forEach((panel, index) => {
          panel.hidden = index !== this.step;
          panel.querySelectorAll('[data-answer]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.answer === this.answers[this.keys[index]])));
        });
        const progress = this.querySelector('[data-progress]');
        progress.hidden = resultsMode;
        progress.textContent = this.messages.step.replace('[number]', String(this.step + 1));
        this.querySelector('[data-results-panel]').hidden = !resultsMode;
        this.querySelector('[data-action="back"]').hidden = this.step === 0;
        this.querySelector('[data-action="restart"]').hidden = !resultsMode;
        if (resultsMode) {
          const results = this.querySelector('[data-results]');
          results.replaceChildren();
          const matches = this.matchingCandidates();
          matches.forEach(template => results.append(template.content.cloneNode(true)));
          const conflict = this.answers.purpose === 'dueling' && ['effects', 'custom'].includes(this.answers.priority);
          this.querySelector('[data-results-title]').textContent = matches.length ? this.messages.title : this.messages.empty_title;
          this.querySelector('[data-summary]').textContent = this.keys.map((key, index) => this.panels[index].querySelector(`[data-answer="${this.answers[key]}"] strong`).textContent).join(' · ');
          const explanation = !matches.length ? (conflict ? this.messages.contact : this.messages.empty) : this.answers.priority === 'unsure' && this.answers.purpose !== 'dueling' ? this.messages.unsure : this.messages[matches[0].dataset.core];
          this.querySelector('[data-explanation]').textContent = explanation;
          this.querySelector('[data-recovery]').hidden = matches.length > 0;
          this.querySelector('[data-action="baselit"]').hidden = !conflict;
          this.querySelector('[data-configuration-note]').hidden = matches.length === 0;
        }
        if (focus) {
          const target = resultsMode ? this.querySelector('[data-results-title]') : this.panels[this.step].querySelector('legend');
          target.focus({ preventScroll: true });
          const rect = this.querySelector('.sx-finder__surface').getBoundingClientRect();
          const headerHeight = document.querySelector('header')?.getBoundingClientRect().height || 0;
          if (rect.top < headerHeight) window.scrollBy({ top: rect.top - headerHeight - 16, behavior: 'instant' });
        }
      }
    }
    customElements.define('saber-finder', SaberFinder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sx-saber-school"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sx-school-video')) {
  customElements.define('sx-school-video', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const button = this.querySelector('[data-school-play]');
      const template = this.querySelector('template');
      if (!button || !template) return;
      this.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const video = template.content.querySelector('video').cloneNode(true);
        video.addEventListener('play', () => {
          this.closest('.sx-school').querySelectorAll('sx-school-video video').forEach(other => {
            if (other !== video) other.pause();
          });
        });
        video.addEventListener('error', () => {
          this.querySelector('.sx-school__video-error').hidden = false;
        });
        button.replaceWith(video);
        video.focus({ preventScroll: true });
        video.play().catch(() => {});
      }, { once: true });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  class LoadMedia extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('button');
      const deferredMediaBtn = this.closest('.video-section').querySelector('.js-load-media');
      button.addEventListener('click', () => deferredMediaBtn.click());
    }
  }
  customElements.define('load-media', LoadMedia);

  } catch(e) { console.error(e); }
})();
})();
